<template lang="pug">
div
  ul#cpicontainertab.nav.nav-tabs(role='tablist')
    li.nav-item.cpi-item(@click="refresh('cpi')")
      a#cpi-tab.nav-link(:class="{ 'active': currTab == 'cpi' }" data-toggle='tab' href='#cpi-content' role='tab' aria-controls='cpi' aria-selected='false') {{ $t("ui.cpi_member_list") }}
    template(v-if="!['MYR'].includes(getCurrencyCode)")
      li.nav-item.cpicustomlist-item(@click="refresh('cpicustomlist')")
        a#cpicustomlist-tab.nav-link(:class="{ 'active': currTab == 'cpicustomlist' }" data-toggle='tab' href='#cpicustomlist-content' role='tab' aria-controls='cpicustomlist' aria-selected='false') {{ $t("ui.cpi_custom_list") }}
      li.nav-item.cpioperatorphone-item(@click="refresh('cpioperatorphone')")
        a#cpioperatorphone-tab.nav-link(:class="{ 'active': currTab == 'cpioperatorphone' }" data-toggle='tab' href='#cpioperatorphone-content' role='tab' aria-controls='cpioperatorphone' aria-selected='false') {{ $t("ui.cpi_operator_phone_list") }}

  #cpicontainertabcontent.tab-content.tab-bordered
    #cpi-content.tab-pane.fade(:class="{ 'active show': currTab == 'cpi' }" role='tabpanel' aria-labelledby='cpi-tab')
      cpiMemberListTab(ref="cpiMemberListTab")
    template(v-if="!['MYR'].includes(getCurrencyCode)")
      #cpicustomlist-content.tab-pane.fade(:class="{ 'active show': currTab == 'cpicustomlist' }" role='tabpanel' aria-labelledby='cpicustomlist-tab')
        cpiCustomListTab(ref="cpiCustomListTab")
      #cpioperatorphone-content.tab-pane.fade(:class="{ 'active show': currTab == 'cpioperatorphone' }" role='tabpanel' aria-labelledby='cpioperatorphone-tab')
        cpiOperatorPhoneListTab(ref="cpiOperatorPhoneListTab")

</template>

<script>
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import cpiMemberListTab from "@/components/operatorTab/cpiMemberListTab.vue";
import cpiCustomListTab from "@/components/operatorTab/cpiCustomListTab.vue";
import cpiOperatorPhoneListTab from "@/components/operatorTab/cpiOperatorPhoneListTab.vue";

export default {
  components: {
    SubmitButton,
    cpiMemberListTab,
    cpiCustomListTab,
    cpiOperatorPhoneListTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'cpi'
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {  },
  beforeDestroy: function() {
    if(this.$refs.cpiMemberListTab) {
      this.destroyTimer();
    }
  },
  methods: {
    destroyTimer: function() {
      this.$refs.cpiMemberListTab.destroyTimer();
    },
    refresh: function(tab) {
      if(this.currTab == 'cpi' && tab != 'cpi') {
        this.destroyTimer();
      }
      switch(tab) {
        case 'cpi':
          this.currTab = 'cpi'
          if(this.$refs.cpiMemberListTab) {
            this.$refs.cpiMemberListTab.refresh();
          }
          break
        case 'cpicustomlist':
          this.currTab = 'cpicustomlist'
          if(this.$refs.cpiCustomListTab) {
            this.$refs.cpiCustomListTab.refresh();
          }
          break
        case 'cpioperatorphone':
          this.currTab = 'cpioperatorphone'
          if(this.$refs.cpiOperatorPhoneListTab) {
            this.$refs.cpiOperatorPhoneListTab.refresh();
          }
          break
      }
    }
  }
};
</script>
